import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Cancel from '../views/Cancel.vue'
import Book from '../views/Book.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/:purl',
    name: 'book',
    component: Book
  },
  {
    path: '/cancel/:purl',
    name: 'cancel',
    component: Cancel
  },
  { path: "/:pathMatch(.*)*", component: Home }  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,/*
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },*/
})

export default router
